import { update } from '@intercom/messenger-js-sdk'

let modalCount = 0

// The launcher/notifications state to restore once no dialog is forcing them
// hidden. `IntercomWidget` keeps this in sync with screen size (mobile hides
// the native launcher in favor of MobileIntercomButton; desktop keeps it) and
// any explicit show request, so the modal-count restore path below never has
// to guess — and never wrongly force-shows the native UI on mobile.
let baselineHidden = false

// `hide_default_launcher` only hides the round chat bubble. Intercom's unread
// "new message" toast (the notifications frame) is a separate surface that
// ignores that setting entirely, so it must be toggled via `hide_notifications`
// in lockstep or it keeps floating on screen after the launcher is gone.
function applyIntercomVisibility(hidden: boolean): void {
    update({ hide_default_launcher: hidden, hide_notifications: hidden })
}

export function setIntercomBaselineHidden(hidden: boolean): void {
    try {
        baselineHidden = hidden
        if (modalCount === 0) {
            applyIntercomVisibility(hidden)
        }
    } catch {
        // ignore errors from Intercom SDK
    }
}

export function pushIntercomModal(): void {
    try {
        modalCount = modalCount + 1
        if (modalCount === 1) {
            applyIntercomVisibility(true)
        }
    } catch {
        // ignore errors from Intercom SDK
    }
}

export function popIntercomModal(): void {
    try {
        modalCount = Math.max(0, modalCount - 1)
        if (modalCount === 0) {
            applyIntercomVisibility(baselineHidden)
        }
    } catch {
        // ignore errors from Intercom SDK
    }
}

export function resetIntercomModalCount(): void {
    try {
        modalCount = 0
        applyIntercomVisibility(baselineHidden)
    } catch {
        // ignore
    }
}
